import React, { useEffect, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { HTTPMethods } from "../../../../../yoello-lib/modules/API/API";
import useFormatCurrency from "../../../../../yoello-lib/modules/localisation/useCurrency";
import { generateExtrasPricingOption } from "../../../../../utils/generateExtrasPricingOption"
import { ReactComponent as VisibleIcon } from "../../../../../assets/images/icon-visible.svg";
import { Theme, makeStyles } from '@material-ui/core/styles';
import { PriceOptionsList } from "./PriceOptions";
import { useAPIV2 } from '../../../../../yoello-lib/modules/API2/useAPIv2';
import APIExtensions from "../../../../../yoello-lib/modules/API2/APIDefs";


export interface IPriceOptionDetailsTooltip {
  id?: string;
  venueId: string;
  isSquare: boolean;
}

const useCurrencyTooltipStyles = makeStyles((theme: Theme) => ({
  root: {
    "& .MuiTooltip-popper": {
      pointerEvents: "unset!important",
    }
  },
  arrow: {
    color: "#2D3A59",
  },
  tooltip: {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 20px rgba(33, 33, 33, 0.15)",
    borderRadius: "10px",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    height: "auto",
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    fontStyle: "normal",
    fontWeight: "normal",
    padding: "0.9375rem 3.125rem",
    maxWidth: "unset!important"
  },
}));
export function PriceOptionDetailsTooltip({ id, isSquare, venueId }: IPriceOptionDetailsTooltip) {
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { formatCurrency } = useFormatCurrency();
  const [extraPricingOptions, setExtraPricingOptions] = useState<any>(undefined);
  const { callAPI: menuItemAPICall } = useAPIV2(APIExtensions.menusItems, {
    onMountDisabled: true,
    yoelloAPIParams: { venue_id: venueId, include_disabled: true  },
  });
  useEffect(() => {

    if (id && open) {
      setIsLoading(true);
      menuItemAPICall(HTTPMethods.GET, {
        query: id,
        getChildrenData: true
      }).then((menuItem) => {
        if (menuItem.isSuccessful) {
          setExtraPricingOptions(generateExtrasPricingOption(menuItem.data, isSquare, formatCurrency));
        }
        setIsLoading(false);
      })
    }
    // eslint-disable-next-line
  }, [open])
  const classes = useCurrencyTooltipStyles();
  const handleTooltipClose = (e: any) => {
    e.stopPropagation();
    setOpen(false);
  };

  const handleTooltipOpen = (e: any) => {
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={classes.root}>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          classes={classes}
          title={<PriceOptionsList priceOptions={extraPricingOptions} isLoading={isLoading} />}
          placement="top"
        >
          <div onClick={handleTooltipOpen} style={{ display: "flex" }}>
            <VisibleIcon height="1.25rem" width="1.25rem" data-component-name="VIEW_ITEM_DETAILS_BUTTON" />
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>

  );
}